import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1a8c1b33&scoped=true&lang=scss"
script.__scopeId = "data-v-1a8c1b33"

export default script